import { createContext, useContext } from 'react';
import { NativeAppMessenger } from './NativeAppMessenger';

export const NativeAppMessengerContext = createContext<NativeAppMessenger | null>(null);

export const useNativeAppMessenger = () => useContext(NativeAppMessengerContext);
